export default __webpack_public_path__ + "static/2-3-0-0-ed150dd825c71bf9434d5fb940a0dd00.jpg";